import * as React from 'react';
import { useState } from 'react';
import RenderControls, { ControlConfig } from '../../components/ra-list/RenderControls';
import RaList from '../../components/ra-list/RaList';
import {
    FunctionField,
    TextField,
    Datagrid
} from 'react-admin';
import { formatDateTime } from '../../components/ex_dayjs';
import { IData } from '../../types';

const ReceiptsCounter = () => {
    const [sortModel] = useState(['EventDate desc']);
    const [defaultValueFilter] = useState<IData>({
        site_id_eq: ''
    });
    const filters: ControlConfig[] = [
        { component: 'text', name: 'site_id_eq', label: 'Event ID', xs: 1.5 },
        { component: 'text', name: 'EventName_eq', label: 'Event Name', xs: 1.5 },
        { component: 'date', name: 'EventDate_eq', label: 'Event Date', xs: 1.5 }
    ];

    return (
        <>
            <RaList
                perPage={25}
                title={'Receipts Counter'}
                sortby={sortModel}
                filters={
                    <RenderControls
                        filterInline={true}
                        controls={filters}
                        defaultValues={defaultValueFilter}
                    />
                }
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField label="User email" source="mailUser" />
                    <TextField label="Tix number" source="count" />
                    <TextField label="Receipt numbers" source="orderNumbers" />
                    <TextField label="Event name" source="eventName" />
                    <FunctionField label="Event date" source="eventDate" render={(record: any) => formatDateTime(record.eventDate)} />
                </Datagrid>
            </RaList >
        </>
    );
};

export default ReceiptsCounter;
